// To keep track of the browser history
import {createBrowserHistory} from  'history';

export default createBrowserHistory();